import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const VirtualConnectionDownstreamDashboardsFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamDashboardsFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DashboardSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
